import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { slugToOsis } from '../constants/bibleConstants';

/**
 * Fallback when the SPA handles a /bible/... URL (e.g. cached app shell).
 * Redirects human-readable SEO paths to the interactive reader.
 */
function BibleRedirect() {
  const { bookSlug, chapterId, verseId } = useParams();
  const osisId = slugToOsis(bookSlug);

  if (!osisId || !chapterId) {
    return <Navigate to="/reader" replace />;
  }

  const readerPath = verseId
    ? `/reader/${osisId}/${chapterId}/${verseId}`
    : `/reader/${osisId}/${chapterId}`;

  return <Navigate to={readerPath} replace />;
}

export default BibleRedirect;